import Select from './components/select';
import Tab from './components/tab';
import $ from 'jquery';


export default class Formation {
    constructor() {
        this.ajaxState = false;
        this.hrefOfpage = window.location.href.split(window.location.origin)[1];
    }

    init() {
        //this.filterHandler();
        //this.paginationHandler();
        this.readMoreHandler();

        this.testimonialCarrousel();
        this.onCloseModal();
        this.onShownModal();

        if (window.matchMedia("(max-width: 640px)").matches) {
            this.formationPostsCarrousel();
            this.boxsCarrousel();
            this.similairPostCarrousel();
            this.mobTabs();
            this.mobShowDetails();
        }

        
    }

    

    // paginationHandler() {
    //     $(document).on('click', '.pagination a', (event) => {
    //         // Stop the browser from submitting the form.
    //         event.preventDefault();

    //         let id = $(event.target).data('page');
    //         let form = $('.filters form');

    //         if (!this.ajaxState) {
    //             let pageId = id;
    //             // send filter form
    //             form.trigger('submit', [pageId]);

    //             $('html, body').animate({
    //                 scrollTop: $(".formations-list-results").offset().top
    //             }, 500);
    //         }
    //     });
    // }

    readMoreHandler() {
        const _self  = this;

        $(document).on('click', '.post-formation .btn-more:not(.footer-btn-more)', function(e) {
            e.preventDefault();

            if ($('.modal-formation').length) {
                // Hide Modal
                $('.modal-formation').modal('hide');
            }
 
            const that = $(this);

            let loader = '<div class="wait-loading"></div>';

            let url = $(".formations-list-results").data('action');

            let id = $(this).parents('.post-formation').data('id');

            $('body').append(loader);

           

            $.ajax({
                url: url,
                type: "get",
                data: {
                    id: id,
                },
                success: (response) => {

                    let obj = typeof response == 'string' ? JSON.parse(response) : response;
                    
                    $('#main').append(obj.items).promise().done(() => {
                        $('.wait-loading').remove();

                        let parent = $('.modal-formation').find('.post-details');
                        
                        // init select
                        const select = new Select(document.querySelectorAll('.modal-formation .s-select'));
                        select.init();
                        
                        // init tab
                        const tab = new Tab();
                        tab.init();
                        
                        // show modal
                        $('.modal-formation').modal('show');

                        if(($('.post-formation-sing-up select option').length)<3) {
                            $('.post-formation-sing-up .ss-arrow').hide();
                          }
                          
                          $(".post-formation-sing-up .ss-single-selected").on("click", function () {
                            if(($('.post-formation-sing-up select option').length)<3) {
                              $('.post-formation-sing-up .ss-arrow').hide();
                              $(".post-formation-sing-up .ss-content").hide();
                              var topOfElement = document.querySelector('.details-formation-sessions').offsetTop;
                              document.querySelector(".modal-content").scroll({ top: topOfElement, behavior: "smooth" });
                            }
                          }); 

                        let baseUrl = window.location.origin;
                        let idUrl = that.get(0).hasAttribute('href') ? that.attr('href') : '';

                        history.pushState({}, '', idUrl.split(baseUrl)[1]);

                        _self.onCloseModal();
                        _self.onShownModal();
                        _self.singUpFormation();
                        _self.testimonialCarrousel();

                        if (window.matchMedia("(max-width: 640px)").matches) {
                            _self.boxsCarrousel();
                            _self.similairPostCarrousel();
                            _self.mobTabs();
                            _self.mobShowDetails();
                        }
 
                    });
                },
                error: function (xhr) {
                    console.error(xhr);
                }
            });
        });
    }
    
    singUpFormation() {
        let selector = $('select[name="f-ville"]');
        
        if (!selector.length) return;

        selector.on('change', (e)=>{
           
            let that = $(e.target);
            let url = that.data('action');
            let params = { 
                "formation": that.data('formation'), 
                "f-ville": that.val() 
            };

            if(!this.ajaxState) {
                this.ajaxState = true;

                $.get(url, params, function (response) {

                    let obj = typeof response == 'string' ? JSON.parse(response) : response;

                    $('.list-session-results').html(obj.items);
                    
                    // re-init select
                    let selects = $('select[name="f-ville"]');
                    
                    for (let index = 0; index < selects.length; index++) {
                        const element = selects[index];
                        element.slim.set(that.val());
                    }

                    if (that.parent().parent().hasClass('post-formation-sing-up')) {
                        // $('.modal-content').animate({
                        //     scrollTop: $(".details-formation-sessions").offset().top
                        // }, 700); 
              
                      // scrollToElement('.modal-content-right', {
                      //   offset: 50,
                      //   ease: 'out-bounce', 
                      //   duration: 1500
                      // });
                      var topOfElement = document.querySelector('.details-formation-sessions').offsetTop;
                      document.querySelector(".modal-content").scroll({ top: topOfElement, behavior: "smooth" });
                      //$('.details-formation-sessions .list-session-infos ').show();
            
                      //$('.details-formation-sessions .lead').get(0).scrollIntoView();


                    }

                }).done(() => {
                    this.ajaxState = false;
                });
            } 
        });
    }

    testimonialCarrousel() {
        let owl = $('.list-testimonial');

        if (!owl.length > 1) return; 
        
        owl.owlCarousel({
            items: 1,
            nav: false,
            margin: 40,
            loop: true,
            responsive: {
                // breakpoint from 0 up
                992: {
                    nav: true,
                    dots: false,
                    navText: ["<span class='icon-arrow-left'></span>", "<span class='icon-arrow-right'></span>"],
                }

            }
        });
    }

    // Enable in mobile
    formationPostsCarrousel() {
        
        let owl = $(".formations-list-posts");

        if (!owl.length > 1) return;

        $.each(owl, function () {

            $(this).owlCarousel({
                items: 1,
                loop: true,
                margin: 40,
            });

        });
        
    }

    onCloseModal() {
        
        if (!$('.modal-formation').length) return;

        $('.modal-formation').on('hidden.bs.modal', (e) => {

            if ($('.modal-formation').length) {
                // remove old modal
                $('.modal-formation').remove();
            }

            let baseUrl = window.location.origin;
            history.pushState({}, '', this.hrefOfpage);

        });
    }

    boxsCarrousel() {
        let owl = $('.list-boxs');

        if (!owl.length) return;

        $.each(owl, function(){

            $(this).owlCarousel({
                items: 1
            });

        });
    }

    similairPostCarrousel() {
        let owl = $('.details-formation-posts .owl-carousel');

        if (!owl.length) return;

        owl.owlCarousel({
            items: 1,
            margin: 40,
            loop: true
        });
    }

    mobTabs() {
        let items = $('.nav-tabs');
        let button = items.find('> .nav-item');

        if (!items.length) return;

        $.each(items.find(' > .nav-item'), function() {
            $(this).not('.active').attr('style', 'display: none !important');
        });

        button.on('click', function() {
            if (!$(this).parent().hasClass('open')) {
                $(this).parent().addClass('open');
                $(this).parent().find('.nav-item').removeAttr('style');
            } else {
                let element = $(this);
                $(this).parent().find('.nav-item').attr('style', 'display: none !important');
                $(this).parent().prepend(element.removeAttr('style'));
                $(this).parent().removeClass('open');
            }
        });
    }

    mobShowDetails() {
        let button = $('.post-formation-show-details button');

        button.on('click', function() {
          
            let element = $(this).parents('.modal-formation').find('.post-details');
          
            if ($(this).hasClass('show')) {
                element.hide();
                $(this).removeClass('show');
            } else {
                element.show();
                $(this).addClass('show');
                $(this).parents('.modal-formation').find('.modal-content').animate({
                    scrollTop: element.position().top
                }, 500);
            }
        });
    }

    onShownModal() {
        const _self = this;
        $('.modal-formation').on('shown.bs.modal', function (e) {
            _self.singUpFormation();
            if (window.matchMedia("(max-width: 640px)").matches) {
                $(this).find('.modal-body > div').append($(this).find('.button-close'));
            }


            $('.go-back').on('click', function (e) {
                e.preventDefault();
                $(".button-close").trigger('click');
            });

        });
    }
}